module.exports = __webpack_public_path__ + "img/sherweb_logo.07832de6.svg";